import FilterText from './FilterText';
import FilterNumber from './FilterNumber';
import FilterSingleSelect from './FilterSingleSelect';
import FilterMultiSelect from './FilterMultiSelect';
import FilterDate from './FilterDate';
import {getTranslation} from './translations';

/* eslint-disable no-undef */
const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
    <div class="ubf-dynamicList__filterContainer" :class="{ 'isActive': isActive }">
		<button class="ubf-dynamicList__filterTitle" @click="onClick" :aria-expanded="isActive ? true : false" :aria-controls="definition.id">
			<span class="ubf-dynamicList__label" :title="description">{{ title }}</span>
			<span class="ubf-dynamicList__titleIcon"><span data-type="svg"><canvas width="12" height="12"></canvas><svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><use xlink:href="#triangle-right"></use></svg></span></span>
		</button>
		<div class="ubf-dynamicList__filterWidget" :id="definition.id">
			<template v-if="type === 'text' || type === 'textarea'  || type === 'link' ">
				<ubfdl-filtertext :label="title" :value="value" :description="description" @change="onFilterChange" @input="onFilterInput"></ubfdl-filtertext>
			</template>
			<template v-else-if="type === 'number'">
				<ubfdl-filternumber :label="title" :value="localValue" :description="description" @change="onFilterChange" @input="onFilterInput"></ubfdl-filternumber>
			</template>
			<template v-else-if="type === 'date' || type === 'interval'">
				<ubfdl-filterdate :label="title" :from="localValue.from" :to="localValue.to" :description="description" @change="onFilterChange" @input="onFilterInput"></ubfdl-filterdate>
			</template>
			<template v-else-if="type === 'single-select'">
				<ubfdl-filtersingleselect :label="title" :value="localValue" :description="description" :preset="preset" @change="onFilterChange"></ubfdl-filtersingleselect>
			</template>
			<template v-else-if="type === 'multi-select'">
				<ubfdl-filtermultiselect
				:label="title"
				:value="localValue"
				:description="description"
				:preset="preset"
				:info="definition.filterOperator === 'OR' ? trans('oneMustApply') : trans('allMustApply')"
				@change="onFilterChange"></ubfdl-filtermultiselect>
			</template>
			<div v-else>
			  Unkown Type: {{ type }}
			</div>
		</div>

	</div>

`;

export default {
	template: template,
	emits: ['filter-change'],
	components: {
		'ubfdl-filtertext': FilterText,
		'ubfdl-filternumber': FilterNumber,
		'ubfdl-filtersingleselect': FilterSingleSelect,
		'ubfdl-filtermultiselect': FilterMultiSelect,
		'ubfdl-filterdate': FilterDate,
	},
	props: {
		definition: Object,
		value: [String, Number, Array, Object, Date]
	},
	setup: function (props, ctx) {
		// initialize default value per type
		let defaultValue = '';
		if (props.definition.type === 'number') {
			defaultValue = '';
		} else if (props.definition.type === 'single-select') {
			defaultValue = '';
		} else if (props.definition.type === 'multi-select') {
			defaultValue = [];
		} else if (props.definition.type === 'date' || props.definition.type === 'interval') {
			defaultValue = {
				from: '',
				to: '',
			};
		} else {
			defaultValue = '';
		}
		const localValue = ref(defaultValue);

		// keep local value in sync with prop from parent
		watch(
			() => props.value,
			(newVal) => {
				if (typeof newVal !== 'undefined') {
					localValue.value = newVal;
				} else {
					localValue.value = defaultValue;
				}
			},
			{immediate: true}
		);

		let presetArray = null;
		if (props.definition.hasOwnProperty('preset')) {
			//presetArray = props.definition.preset.map((item) => ({value: item, label: item}));
			presetArray = props.definition.preset;
		}
		return {
			trans: getTranslation,
			isActive: ref(false),
			localValue: localValue,
			id: props.definition.id,
			type: props.definition.type,
			title: props.definition.title,
			filterable: props.definition.filterable,
			description: props.definition.description,
			preset: presetArray
		};
	},
	methods: {
		onClick: function () {
			this.isActive = !this.isActive;
		},
		onOptionSelected: function (value) {
			if (this.type === 'single-select') {
				this.localValue = value.value;
			} else {
				if (Array.isArray(this.localValue)) {
					this.localValue.push(value.value);
				} else {
					this.localValue = [value.value];
				}
			}
			this.$emit('filter-change', {id: this.id, type: this.type, value: this.localValue});
		},
		onOptionDeselected: function (value) {
			if (this.type === 'single-select') {
				this.localValue = [];
			} else {
				const index = this.localValue.indexOf(value.value);
				if (index > -1) { // only splice array when item is found
					this.localValue.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
			this.$emit('filter-change', {id: this.id, type: this.type, value: this.localValue});
		},
		onFilterChange: function (value) {
			this.localValue = value;
			this.$emit('filter-change', {id: this.id, type: this.type, value: this.localValue});
		},
		onFilterInput: function (value) {
			console.log('onFilterInput', value);
			this.$emit('filter-change', {id: this.id, type: this.type, value: value});
		},
	},
};

